








import { Component, Mixins, Vue } from 'vue-property-decorator'
import StudentTable from '@/components/branch/organisms/StudentTable.vue'
import StudentListApis, { StudentData } from '@/mixins/requests/branch/StudentListApis.vue'

@Component({
  components: {
    StudentTable,
  },
})
export default class StudentList extends Mixins(StudentListApis) {
  private studentList: StudentData[] = []

  private async mounted() {
    Vue.prototype.$loading.start()
    try {
      this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private onClickSearch() {
    Vue.prototype.$loading.start()
    try {
      this.search()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private async search() {
    this.studentList = await this.searchStudents()
  }

  private onClickComfirmButton(acbtCode: string) {
    this.$router.push({ name: 'BranchStudyResult', params: { acbtCode: acbtCode } })
  }
}
